// ** react imports
import React from 'react';

// ** router imports
import { NavLink, useParams, useSearchParams } from 'react-router-dom';

const CustomerSettingsSidebar = () => {
  // hooks
  const [searchParams] = useSearchParams();
  const page = searchParams.get('page');
  const { id } = useParams();

  return (
    <div className="flex flex-nowrap overflow-x-scroll no-scrollbar md:block md:overflow-auto px-3 py-6 border-b md:border-b-0 md:border-r border-gray-200 dark:border-gray-700/60 min-w-[15rem] md:space-y-3">
      <div>
        <div className="text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase mb-3">
          Customer settings
        </div>
        <ul className="flex flex-nowrap md:block mr-3 md:mr-0">
          <li className="mr-0.5 md:mr-0 md:mb-0.5">
            <NavLink
              end
              to={`/customers/details/${id}?page=profile`}
              className={`flex items-center px-2.5 py-2 rounded-lg whitespace-nowrap ${
                page === 'profile' &&
                'bg-linear-to-r from-violet-500/[0.12] dark:from-violet-500/[0.24] to-violet-500/[0.04]'
              }`}
            >
              <svg
                className={`shrink-0 fill-current mr-2 ${
                  page === 'profile'
                    ? 'text-violet-500 dark:text-violet-400'
                    : 'text-gray-400 dark:text-gray-500'
                }`}
                width="16"
                height="16"
                viewBox="0 0 16 16"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M20 22H18V20C18 18.3431 16.6569 17 15 17H9C7.34315 17 6 18.3431 6 20V22H4V20C4 17.2386 6.23858 15 9 15H15C17.7614 15 20 17.2386 20 20V22ZM12 13C8.68629 13 6 10.3137 6 7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7C18 10.3137 15.3137 13 12 13ZM12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"></path>
                </svg>
              </svg>
              <span
                className={`text-sm font-medium ${
                  page === 'profile'
                    ? 'text-violet-500 dark:text-violet-400'
                    : 'text-gray-600 dark:text-gray-300 hover:text-gray-700 dark:hover:text-gray-200'
                }`}
              >
                Profile
              </span>
            </NavLink>
          </li>
          <li className="mr-0.5 md:mr-0 md:mb-0.5">
            <NavLink
              end
              to={`/customers/details/${id}?page=tax-files`}
              className={`flex items-center px-2.5 py-2 rounded-lg whitespace-nowrap ${
                page === 'tax-files' &&
                'bg-linear-to-r from-violet-500/[0.12] dark:from-violet-500/[0.24] to-violet-500/[0.04]'
              }`}
            >
              <svg
                className={`shrink-0 fill-current mr-2 ${
                  page === 'tax-files'
                    ? 'text-violet-500 dark:text-violet-400'
                    : 'text-gray-400 dark:text-gray-500'
                }`}
                width="16"
                height="16"
                viewBox="0 0 16 16"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M11 7H13V17H11V7ZM15 11H17V17H15V11ZM7 13H9V17H7V13ZM15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"></path>
                </svg>
              </svg>
              <span
                className={`text-sm font-medium ${
                  page === 'tax-files'
                    ? 'text-violet-500 dark:text-violet-400'
                    : 'text-gray-600 dark:text-gray-300 hover:text-gray-700 dark:hover:text-gray-200'
                }`}
              >
                Tax Files
              </span>
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CustomerSettingsSidebar;
